// eslint-disable-next-line import/no-unresolved
import brand from '@brand/brand.js';
import { Transition } from '@headlessui/react';
import { useEffect, useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { ErrorMessage } from './error-message';

function useLatestNonEmpty(next) {
  const latestRef = useRef(next);

  useEffect(() => {
    if (next && next !== latestRef.current) {
      latestRef.current = next;
    }
  }, [next]);
  return latestRef.current;
}

export function ErrorBlock({ error }) {
  const { t } = useTranslation();
  return (
    <Transition
      show={!!error}
      enter="transition-opacity duration-150"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-150"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <ErrorMessage
        title={t(error?.title, { ns: 'common' })}
        details={
          <Trans
            i18nKey={error?.details}
            ns="common"
            components={{
              ul: <ul />,
              li: <li />,
            }}
            values={brand}
          />
        }
        className="!mb-2.5"
      />
    </Transition>
  );
}
